import {Component, inject, Input} from '@angular/core';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';

@Component({
  selector: 'app-link',
  imports: [
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './link.component.html'
})
export class LinkComponent {
  router = inject(Router)

  @Input()
  text: string;

  @Input()
  routerLink: any[];

  @Input()
  route: string

}
